import React from "react";
import NewAirportContent from "../components/airports/new-airport-content";

const NewAirport = () => {
  return <NewAirportContent />;
};

export default NewAirport;
